import { cn } from "@/lib/utils";
import ResourcesTextCard from "@/components/ui/resources-text-card";

export type ArticleCard = {
  title: string;
  titleHref: string;
  text: string;
  leftInfo: string;
  rightInfo: string;
};

export interface RelatedArticlesProps {
  articles: ArticleCard[];
}

const RelatedArticles: React.FC<RelatedArticlesProps> = ({ articles }) => {
  return (
    <div className="flex h-fit w-full flex-col gap-4">
      <h2 className="font-montserrat text-subheading-2 text-neutral-500">
        Related Articles
      </h2>
      {articles && articles.length > 0 ? (
        <ul
          className="grid grid-cols-1 gap-6"
          aria-label="List of related articles"
          role="list"
        >
          {articles.map((article, index) => (
            <li
              key={`${article.title}-${index}`}
              role="listitem"
              className={cn(index > 1 && "hidden lg:grid")}
            >
              <ResourcesTextCard
                cardType="no-image"
                title={article.title}
                titleHref={article.titleHref}
                text={article.text}
                leftInfo={article.leftInfo}
                rightInfo={article.rightInfo}
              />
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-subheading-4-400 font-montserrat text-neutral-600">
          No related articles found.
        </p>
      )}
    </div>
  );
};

export default RelatedArticles;
